<script setup lang="ts">
import { onMounted, watch } from "vue";
import { config } from "@/lib/variantConfig";
import { useThemeStore } from "@/stores/themeStore";

const themeStore = useThemeStore();

const setCssVars = () => {
  const root = document.documentElement;
  const colors = config.colors[themeStore.theme];
  for (const [key, value] of Object.entries(colors)) {
    const keyName = key.replace(/_/g, "-");
    root.style.setProperty(`--color-${keyName}`, String(value));
  }
};

onMounted(() => {
  themeStore.setListener();
  setCssVars();
});

watch(
  () => themeStore.theme,
  () => {
    setCssVars();
  }
);
</script>

<template>
  <slot />
</template>
